import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrentUser } from '../../services/current-user.service';
import moment from 'moment';

@Pipe({
    name: 'userDate',
    standalone: false
})
export class UserDatePipe extends DatePipe implements PipeTransform {
  constructor(public user: CurrentUser) {
    super('en-US');
  }

  transform(value: any, args?: any): any {
    if (this.user && this.user.dateFormats.display.dateInput) {
      var date = moment(value);
      if (date.isValid()) {
        if (args && args === 'time') {
          return date.format(this.user.getDateTimeFormat());
        }
        return date.format(this.user.dateFormats.display.dateInput);
      } else {
        return "";
      }
    }

    return super.transform(value, 'dd/MM/yyyy');
  }
}

